
import message from '@/assets/icons/notify-message-company-x16.png'

import action from '@/assets/icons/notify-action-company-x16.png'

import timeIcon from '@/assets/icons/notify-time-clock-icon.png'

import auditIcon from '@/assets/icons/notify-action-audit-x16.png'

import trajectoryEvent from '@/assets/icons/trajectoryEvent.png'

import trajectoryErrorEvent from '@/assets/icons/trajectoryErrorEvent.png'
import success_remind from '@/assets/icons/success_remind.png'
import danger_remind from '@/assets/icons/danger_remind.png'

import file from '@/assets/icons/file.png'

import lang from '@/lang'

export class MsgNotifyConstants {
  constructor(data) {
    this.CRM_ASSIGN_SALER = { 'actionCode': 'AAAA01', 'topic': lang.t('Message.AssignSales'), 'icon': action }
    this.CRM_RELEASE_SALER = { 'actionCode': 'AAAA02', 'topic': lang.t('Message.ReleaseSales'), 'icon': action }
    this.CRM_ADUIT_SALER = { 'actionCode': 'AAAA03', 'topic': lang.t('Message.ReviewSales'), 'icon': action }
    this.CRM_APPROVED_SALER = { 'actionCode': 'AAAA04', 'topic': lang.t('Message.SuccessfullyGrabCustomer'), 'icon': action }
    this.CRM_REJECTED_SALER = { 'actionCode': 'AAAA05', 'topic': lang.t('Message.GrabCustomerFailed'), 'icon': action }
    this.CRM_SCHEDULE_SALER = { 'actionCode': 'AAAB01', 'topic': lang.t('Message.ScheduleReminder'), 'icon': message }
    this.CRM_EXPIRE_SALER = { 'actionCode': 'AAAC01', 'topic': lang.t('Message.CustomerExpirationReminder'), 'icon': timeIcon }
    this.ORDER_AUDIT_EVENT = { 'actionCode': 'order_audit_event', 'topic': lang.t('Message.BusinessReviewReminder'), 'icon': auditIcon }
    this.TRAJECTORY_EVENT = { 'actionCode': 'trajectory_event', 'topic': lang.t('Message.CustomsDeclarationReminder'), 'icon': trajectoryEvent }
    this.TRAJECTORY_ERROR_EVENT = { 'actionCode': 'trajectory_error_event', 'topic': lang.t('Message.AbnormalHandlingOfBox'), 'icon': trajectoryErrorEvent }

    this.START_EVENT = { 'actionCode': 'start_event', 'topic': lang.t('Message.DeparturePickUpContainerWarning'), 'icon': trajectoryErrorEvent }
    this.TO_THE_FACTORY_EVENT = { 'actionCode': 'to_the_factory_event', 'topic': lang.t('Message.BoxArrivingAtFactoryWarning'), 'icon': trajectoryErrorEvent }
    this.OFF_FACTORY_EVENT = { 'actionCode': 'off_factory_event', 'topic': lang.t('Message.BoxLeavingFactoryWarning'), 'icon': trajectoryErrorEvent }
    this.CUSTOMS_RELEASE_EVENT = { 'actionCode': 'customs_release_event', 'topic': lang.t('Message.CustomsReleaseWarning'), 'icon': trajectoryEvent }
    this.WHARF_RELEASE_EVENT = { 'actionCode': 'wharf_release_event', 'topic': lang.t('Message.TerminalReleaseWarning'), 'icon': trajectoryEvent }
    this.ABOARD_EVENT = { 'actionCode': 'aboard_event', 'topic': lang.t('Message.BoardingWarning'), 'icon': trajectoryEvent }
    this.DEPARTURE_FROM_EVENT = { 'actionCode': 'departure_from_event', 'topic': lang.t('Message.DepartureWarning'), 'icon': trajectoryEvent }
    this.ARRIVAL_PORT_EVENT = { 'actionCode': 'arrival_port_event', 'topic': lang.t('Message.ArrivalWarning'), 'icon': trajectoryEvent }
    this.RETURN_BOX_EVENT = { 'actionCode': 'return_box_event', 'topic': lang.t('Message.ReturningBoxWarning'), 'icon': trajectoryErrorEvent }
    this.BILLING_SYSTEM_ARREARAGE_REMIND = { 'actionCode': 'billing_system_arrearage_remind', 'topic': lang.t('Message.SystemArrearsReminder'), 'icon': action }

    this.CHANGE_CHARGE_SUCCESS_EVENT = { 'actionCode': 'change_charge_success_event', 'topic': lang.t('Message.ChangeReviewAndApprovalReminder'), 'icon': success_remind }

    this.CHANGE_CHARGE_REFUSE_EVENT = { 'actionCode': 'change_charge_refuse_event', 'topic': lang.t('Message.ChangeReviewAndApprovalReminder'), 'icon': danger_remind }

    this.CHANGE_CHARGE_BACK_EVENT = { 'actionCode': 'change_charge_back_event', 'topic': lang.t('Message.ChangeReviewAndApprovalReminder'), 'icon': trajectoryEvent }

    this.FILE_EXPORT_FINISHED = { 'actionCode': 'FILE_EXPORT_FINISHED', 'topic': lang.t('Message.FileExportCompletionReminder'), 'icon': file }
    this.PRICE_AUDIT_EVENT_FCL = { 'actionCode': 'PRICE_AUDIT_EVENT_FCL', 'topic': lang.t('CargoMsg.Cargo_PriceAuditEventFclTitle'), 'icon': file }

    this.SYNC_PARTNER_TO_FINANCE_CODE = { 'actionCode': 'SYNC_PARTNER_TO_FINANCE_CODE', 'topic': lang.t('Message.SyncPartnerToFinanceCodeReminder'), 'icon': action }

    this.MSG_NOTIFY_DEFAULT = { 'actionCode': 'DEFAULT', 'topic': lang.t('Message.DefaultMessage'), 'icon': action }

    this.TARGET_TYPE_QUOTATION_CLIENT = 'QuotationClient'
    this.TARGET_TYPE_SCHEDULE = 'Schedule'
    /**
       * CRM的操作消息类型
       */
    this.MSSAGE_CRM = ([
      this.CRM_ASSIGN_SALER, this.CRM_RELEASE_SALER, this.CRM_ADUIT_SALER, this.CRM_APPROVED_SALER, this
        .CRM_REJECTED_SALER, this.CRM_SCHEDULE_SALER, this.CRM_EXPIRE_SALER, this.MSG_NOTIFY_DEFAULT, this.ORDER_AUDIT_EVENT, this
        .TRAJECTORY_EVENT, this.TRAJECTORY_ERROR_EVENT, this.START_EVENT, this.TO_THE_FACTORY_EVENT, this.OFF_FACTORY_EVENT, this.CUSTOMS_RELEASE_EVENT, this.WHARF_RELEASE_EVENT, this
        .ABOARD_EVENT, this.DEPARTURE_FROM_EVENT, this.ARRIVAL_PORT_EVENT, this.RETURN_BOX_EVENT, this.CHANGE_CHARGE_SUCCESS_EVENT,
      this.CHANGE_CHARGE_REFUSE_EVENT,
      this.CHANGE_CHARGE_BACK_EVENT,
      this.FILE_EXPORT_FINISHED,
      this.SYNC_PARTNER_TO_FINANCE_CODE
    ])
  }

  /**
   * 根据actionCode获取类型对象
   * @param code
   * @return
   */
  getTypeByActionCode(code) {
    for (const o of this.MSSAGE_CRM) {
      if (o['actionCode'] === code) { return o }
    }
    return this.MSG_NOTIFY_DEFAULT
  }
}
